import { ILanguage } from "./ILanguage";

export class English implements ILanguage {
    logoutConfirmationMessage: string = "Are you sure you want to logout? This will end your current exam session";
    networkFair: string = "Fair: You may experience a little lag, but if the network doesn't degrade, you shouldn't experience any network problems";
    networkPoor: string = "Bad: You may likely experience network issues while taking the exam";
    networkGood: string = "Good: Network looks good. If things remain the same, you should not experience any network problems";
    category: string="Category";
    goBack: string="Go Back";
    unansweredQuestions: string ="Unanswered Questions";
    answeredQuestions: string ="Answered Questions";
    questionList: string ="Question List";
    shortAnswerQuestion: string= "Short Answer Question";
    systemCheck: string = "Run System Check";
    desktop: string = "Desktop";
    mobile: string = "Mobile";
    unknown: string = "Unknown";
    selectLanguage: string = 'Select Language';
    languageName = 'English';
    submitConfirmationMessage: string = 'Are you sure you want to submit? This will end the Exam';
    backToLogin: string = 'Back to Login';
    allComplaints: string = 'All Complaints';
    complaintID: string = 'Complaint ID';
    examNo: string = 'Exam Number';
    lastName: string = 'Last Name';
    firstName: string = 'First Name';
    status: string = 'Status';
    submittedDate: string = 'Submitted Date';
    noComplaint: string = 'No complaint found';
    complaint: string = 'Complaint';
    selectExamComplaint: string = 'Please select the Examination you intend to make a complaint about.';
    natureOfComplaint: string = 'Please select the nature of your complaint.';
    closeComplaints: string = 'Close Complaint';
    closeReply: string = 'Close Reply';
    replyComplaint: string = 'Reply Complaint';
    reply: string = 'Reply';
    enterResponseDetails: string = 'Enter the details of your Response';
    submit: string = 'Submit';
    supportDiscussion: string = 'Support Discussion';
    admin: string = 'Admin';
    you: string = 'You';
    complaintsClosed: string = 'Complaints Closed';
    replySent: string = 'Reply Sent';
    candidateInformation: string = 'Candidate Information';
    viewAllComplaints: string = 'View All Complaints';
    examinationSelection: string = 'Examination Selection';
    complaintsDisabled: string = 'No examination found or Complaints have been disabled for this exam';
    complaintCategory: string = 'Complaint Category';
    selectOption: string = 'Select Option';
    complaintDetails: string = 'Complaint Details';
    solvedYourIssue: string = 'Has the above process solved your issue';
    yes: string = 'Yes';
    no: string = 'No';
    enterComplaintDetails: string = 'Enter the details of your complaint';
    previous: string = 'Previous';
    cancel: string = 'Cancel';
    next: string = 'Next';
    limitOf: string = 'Limit of';
    wordsMaximum: string = 'words maximum';
    welcome: string = 'Welcome';
    logout: string = 'Logout';
    passportSection: string = 'PASSPORT SECTION';
    maxFileUpload1mb: string = 'Max. File Upload is 1mb';
    takePicture: string = 'Take Picture';
    clearFaceInstruction: string = 'Ensure your face is CLEARLY visible in the circle above at all times.';
    secondViewClarityInstruction: string = 'Ensure both your side view and your screen are clearly visible in the video above. Ensure you follow the exam instructions.';
    brightLightInstruction: string = 'Ensure there are no bright lights or windows behind you.';
    requestAttention: string = 'Request Attention';
    uploadPassport: string = 'Upload Passport';
    unableToConnectToServer: string = 'Unable to connect to server. Please check your internet connection or restart your internet modem';
    waitForProctorOk: string = 'Please wait for the proctor to contact you';
    passportChangeErr: string = "Passport cannot be changed after exam starts"
    uploadSuccessful: string = 'Upload Successful';
    savePassport: string = 'Save Passport';
    changePassport: string = 'Change Passport';
    examinationFeedBack: string = 'Examination FeedBack';
    happy: string = 'Happy';
    neutral: string = 'Neutral';
    unhappy: string = 'Unhappy';
    close: string = 'Close';
    problemCategories: string = 'Problem categories';
    othersProblemCategories: string = 'Others (Kindly provide details)';
    login: string = 'Login';
    username: string = 'Username';
    password: string = 'Password';
    makeComplaint: string = 'Need Help?';
    loggedOut: string = 'You are logged out';
    userMis_match: string = 'User Mis-match. Unauthorized Access';
    loginToTakeExam: string = 'Login to take Exam';
    aboutUs: string = 'About Us';
    // allComplaints:string = 'meedsting components';
    error: string = 'Error';
    somethingWentWrong: string = 'Oops! Something went wrong.';
    pleaseConatctAdministrator: string = 'Please conatct the administrator';
    instructions: string = 'Instructions';
    question: string = 'Question';
    pleaseHold: string = 'PLEASE HOLD';
    examHasBeenPaused: string = 'YOUR EXAMINATION HAS BEEN PAUSED';
    reason: string = 'REASON';
    willNotLoseTime: string = 'DURING THIS PERIOD, YOU WILL NOT LOSE ANY TIME AS YOUR EXAMINATION TIMER HAS BEEN PAUSED';
    userSessionNotFound: string = 'User session not found';
    networkConnectionLost: string = 'Network connection lost. Attempting to reconnect';
    multipleLoginsDetected: string = 'Multiple Logins Detected';
    unauthorizedAccess: string = 'Unauthorized Access';
    penalizedWarning: string = 'You are not allowed to leave the exam page. Doing so results in being penalized';
    youHaveLost: string = 'You have lost';
    leavingExamPage: string = 'minutes as the penalty for leaving the exam page';
    finishAndSubmit: string = 'Finish/Submit';
    questionHasBeen: string = 'Question has been';
    verifyingEmail: string = 'Verifying Email';
    registration: string = 'Registration';
    emailAddress: string = 'Email Address';
    verifyEmailAddress: string = 'Verify Email Address';
    otherNames: string = 'Other Names';
    phoneNumber: string = 'Phone Number';
    gender: string = 'Gender';
    selectGender: string = 'Select Gender';
    male: string = 'Male';
    female: string = 'Female';
    scheduleDate: string = 'Schedule Date';
    scheduleTime: string = 'Schedule Time';
    selectTime: string = 'Select Time';
    noAvailableTime: string = 'No availabe time';
    noAvailableDate: string = 'No availabe Date';
    register: string = 'Register';
    registrationSuccessful: string = 'Registration Successful';
    yourRegistrationFor: string = 'Your registration for';
    wasSuccessful: string = 'was successful.';
    yourExaminationNumberIs: string = 'Your Examination Number is';
    checkYourEmailForMoreInformation: string = 'Check your email for more information on the examination.';
    imageSizeIsGreaterthan1mb: string = 'Image size is to greater than 1MB.';
    invalidImageFormat: string = 'Invalid image format';
    pleaseSelectGender: string = 'Please select gender';
    pleaseFillExaminationSchedule: string = 'Please fill Examination Schedule details';
    pleaseUploadPassportPicture: string = 'Please upload passport picture';
    registrationComplete: string = 'Registration Complete';
    verificationEmailSent: string = 'A Verification Email Has been sent to ';
    invalidEmail: string = 'Invalid Email';
    emailVerified: string = 'Email Verified';
    invalidCode: string = 'Invalid code';
    unavailableDateSelected: string = 'Unavailable Date Selected';
    examPlatformUsageInst: string = 'EXAM PLATFORM USAGE INSTRUCTIONS';
    useSafeExamBrowser: string = 'To take this exam, you will be required to use the Safe Exam Browser (SEB) on a computer. To use it, please follow the instructions below.';
    installSafeExamBrowser: string = "If you haven't already installed it, please use the appropriate link below to download it.  If you already have it installed, ";
    //ensureCurrentSEBVersionIsInstalled: string = "Please ensure you have the current version installed.";
    sebUsageInstructionsSkipStep3: string = " If you already have the current version installed, you can skip to step 3.";
    sebDownloadLinkForWindows: string = 'Secure Exam Browser download for Windows';
    sebDownloadLinkForMac: string = 'Secure Exam Browser download for Mac';
    installTheSoftware: string = 'Once downloaded, install the software';
    onceSEBIsInstalled: string = 'Once SEB is installed, click ';
    here: string = 'here';
    downloadSEBexamfileforyourexam: string = 'to download the SEB exam file for your exam.';
    youshouldseefile: string = 'You should see a file that looks like this';
    double_clickdownloadedfile: string = 'To start your exam, double-click the downloaded file.';
    confirmInstallSafeExamBrowser: string = "If the SEB exam file doesn't work, please confirm that you have properly installed SEB, and you are using the correct file downloaded in the link above.";
    //unabletoconnecttoserver: string = 'Unable to connect to server';
    connectionError: string = 'Connection Error';
    unknownserversideerror: string = 'Unknown server side error';
    youhavebeenpreventedfromstarting: string = 'You have been prevented from starting the exam because';
    connectiontomediaserverlost: string = 'Connection to media server lost. Please reconnect';
    verificationError: string = 'Verification Error occured on your system. If this issue persists, please refresh the page or restart your browser';
    unexpectedCondition: string = 'Unexpected Condition. markanswerasync exception';
    loading: string = 'Loading';
    submitExamination: string = 'SUBMIT EXAMINATION';

    submitting: string = 'Submitting';
    yourScore: string = ' Your Score is';
    startNewExam: string = 'Start a new Exam';
    takeExam: string = 'Take Exam';
    join: string = 'Join';
    minutes: string = 'minutes';
    start: string = 'Start';
    continue: string = 'Continue';
    scheduleExam: string = 'Schedule Exam';
    pleaseWait: string = 'Please Wait';
    finished: string = 'Finished';
    timeElapsed: string = 'Time Elapsed';
    disqualified: string = 'Disqualified';
    stopped: string = 'Stopped';
    reschedule: string = 'Reschedule';
    webtestInstruction: string = 'USAGE INSTRUCTIONS';
    agreeToInstructions: string = 'I agree that I have read and understood the above instructions';
    startExam: string = 'Start Exam';
    examSchedule: string = 'Exam Schedule';
    selectDate: string = 'Select Date';
    schedule: string = 'Schedule';
    examScheduled: string = 'Exam Scheduled. Please Check your mail';
    examinationList: string = 'Examination List';
    scheduledExaminations: string = 'Scheduled Examinations';
    ensureyourfacefillsthecircle: string = 'Keep a neutral expression. Ensure your face fills up 90% of the circle. Also make sure your camera lens is clean';
    smileForASecondPhoto: string = 'Smile for a second photo';
    capturePhoto: string = 'Capture Photo';
    captureSmilingPhoto: string = 'Capture Smiling Photo';
    startOver: string = 'Start Over';
    upload: string = 'UPLOAD';
    save: string = 'Save';
    youhavenooutputvideodevice: string = 'You have no output video device';
    errorloadingcustomcssfile: string = 'Error loading custom css file';
    noExamsFound: string = 'No exams found';
    multipleChoice: string = "Multiple-Choice";
    interview: string = "Interview";
    essay: string = "Essay";
    flagged: string = "Flagged";
    unflagged: string = "Unflagged";
    duplicateCameratyprDetected: string = "Multiple camera type detected";
    errorCheckingDuplicateCameras: string = "Error checking for duplicate cameras";
    itRecommendedUseDesktopDevice: string = "It is recommended to use a desktop device for this proctoring system.";
    virtualMachineDetected: string = "Virtual machine detected and running.";
    noWorkingCamerafound: string = "No working camera found.";
    failedToAccessCamera: string = "Failed to access camera:";
    noWorkingMicrophoneFound: string = "No working microphone found.";
    failedToAccessMicrophone: string = "Failed to access microphone:";
    failedToPlaySound: string = "Failed to play sound:";
    failedToEnumerateDevices: string = "Failed to enumerate devices: ";
    developerToolsAreOpen: string = "Developer tools are open";
    available: string = "Available";
    notAvailable: string = "Not Available";
    proctoringSystemCheck: string = "Proctoring System Check";
    camera: string = "Camera";
    speaker: string = "Speaker";
    microphone: string = "Microphone";
    recording: string = "Recording";
    osVersion: string = "OS Version";
    browserVersion: string = " Browser Version";
    deviceType: string = "Device Type";
    virtualMachine: string = " Virtual Machine";
    safeExamBrowser: string = "Safe Exam Browser(SEB)";
    runCheck: string = "Run Check";
    mediaChecks: string = "Media Checks";
    cameraCheck: string = "Camera Check";
    microphoneCheck: string = "Microphone Check";
    speakerCheck: string = "Speaker Check";
    playTestSound: string = "Play Test Sound";
    playingTestSound: string = "Playing test sound";
    unknownBrowser: string = "Unknown Browser";
    unknownVersion: string = "Unknown Version";
    notUsed: string = "Not Used";
    used: string = "Used";
    detected: string = "Detected";
    notDetected: string = "Not detected";
    canHearBeepSound: string = "Did you hear the sound";
    canSeeSelf: string = "Can you see yourself clearly";
    audioNotAvailablePlease:string="Audio is not available. Please check the volume or try again.";
    cameraNotAvailablePlease:string="Camera is not available. Please check the settings or try again.";
    retakeExam: string = "Retake Exam";
    reasonForRetake: string= "Reason for Retake";
    sebMinimumOSVersionWindows: string = "Windows 8.1 or later required";
    sebMinimumOSVersionMac: string = "Mac OS Ventura or later required";
    abbreviatedQuestionNo: string = "Q.No";
    toggleCalculator: string = "Toggle Calculator";
    scoreFetchError: string = "Unable to fetch score, your admin will release your score later"; 
    postSubmitScoreFetching: string = "Submission successful, please wait to see your score...";
    installSebIfNotInstalled: string = "If you do not have SEB (Safe Exam Browser) installed, please follow the instructions for your operating system below to install it. ";
    ifInstalledSebTakeYourExam: string = "If you already have the current version of SEB installed, ";
    clickHereToTakeYourExam: string = "Click here to take your exam. ";
    ifDirectStartLinkDoesNotWOrk: string = "If the link to start your examination does not work, please download the SEB exam file for your exam by clicking ";
    grantSebAllPermissions: string = "Ensure that you grant all permissions requested by SEB";
    furtherInstallationAssistanceneeded: string = "If you need further assistance with starting your exam, please watch the video below:";
    clickToDownloadSEB: string = "Click here to download SEB ";
    ifInstallationOrStartupOfSEBFails: string = "If the installation or startup of SEB fails, you may need to do some or all of the following before proceeding";
    disableOrUninstallYourAntivirus: string = "Disable/Uninstall your antivirus";
    reasonToDisableAntivirusesForSEB: string = "Some antiviruses have been known to interfere with the normal installation and usage of SEB. You may need to completely uninstall the antivirus to proceed.";
    downloadAndInstallVisualCPP: string = "Download and install Visual C++";
    clickHereToDownloadVisualCPP: string = "Click here to download Visual C++.";
    downloadAndInstallDotNetFramework: string = "Download and install .NET Framework";
    clickHereToDownloadAndInstallDotNetFramework: string = "Click here to download .NET Framework.";;
    updateYourOperatingSystem: string = "Update your operating system";
    instructionsToUpdateOperatingSystem: string = "Go to: Windows -> Check For Updates";
    afterTakingTroubleshootingStepsTryReinstallingOrUsingSEB: string = "Once you have done the above, please try installing and using SEB again. If it continues to fail, you may need to use a different device.";
    viewExamInstruction: string = "View Examination Instructions";
    quillEditorReadOnlyDefaultMessage: string = "Editor is in read-only mode..";
    quillEditorPlaceHolderMessage: string = "Type In Your Answer";
    quillEditorEssayReadOnlyMessage: string = "Max questions answered — see exam instructions!";
    clearAnswer: string = "Clear Answer";
    areYouSure: string = "Are you sure?";
    undo: string = "Undo";
    redo: string = "Redo";
    insertTable: string = "Insert table";
    linkedExaminations: string = "Linked Examinations";
    youHaveCompleted: string = "You have completed";
    continueWith: string = "Continue with";
    goBackToLoginPage: string = "Go back to login page";
    listOfComplaints: string = "List of complaints";
    goToDashboard: string = "Go to Exams Dashboard"; 
    zoomControls: string = "Zoom Controls";
    zoomIn: string = "Zoom in to enlarge text";
    zoomOut: string = "Zoom out to reduce text size";
    remaining: string = "remaining";
    and: string = "and";
    seconds: string = "seconds";
    logoutFromTheCurrentSession: string = "Logout from the current session";
    passport: string = "Passport";
    openWebcamForPassport: string = "Open webcam to take passport photo";
    closeCapturePhotoDialog: string = "Close capture photo dialog";
    closeFeedbackModal: string = "Close feedback dialog";
    happyFeedback: string = "Happy feedback";
    neutralFeedback: string = "Neutral feedback";
    unhappyFeedback: string = "Unhappy feedback";
    provideMoreDetails: string = "Provide more details about the issue selected";
    loginHomepage: string = "Login homepage";
    webtestLoginPic: string = "Web Test login";
    companyBadgePic: string = "Company Badge";
    submitLoginForm: string = "Submit login form";
    clickToLogin: string = "Click to login";
    helpfulLinks: string = "Helpful links";
    visitWebtestWebsite: string = "Visit web test.ng website";
    webTestLogo: string = "Web Test";
    questionContent: string = "Question Content";
    loadingQuestionWait: string = "Loading question, please wait...";
    subQuestions: string = "Sub-questions'";
    subQuestion: string = "Sub-question";
    questionIs: string = "is";
    questionSection: string = "Question Section";
    flagQuestionToRevisit: string = "Flag a question to revisit later";
    closeCalculator: string = "Close calculator dialog";
    selectOneOption: string = "Select one option";
    selectAllThatApply: string = "Select all that apply";
    questionNavigation: string = "Question Navigation";
    goToQuestion: string = "Go to question";
    previousQuestion: string = "Previous question";
    nextQuestion: string = "Next question";
    youAreOnTheLastQuestion: string = "You are on the last question";
    richTextEditor: string = "Rich text editor for answer input";
    clearTextConfirmation: string = "Clear text confirmation";
    clearTextConfirmationDescription: string = "This action will permanently delete all text in the editor. Do you want to continue?";
    confirmClearText: string = "Yes, clear all text";
    cancelClearText: string = "No, keep text";
    quillAnswerInputInstruction: string = "Use this rich text editor to enter your answer. You can format text using the toolbar";
    answerArea: string = "Answer area";
    typeInYourAnswer: string = "Type In Your Answer";
    scrollToBottom: string = "Scroll to bottom";
    scrollToTop: string = "Scroll to top";
    loadingWait: string = "Loading, please wait";
    loadingCheck: string = "Loading, system check";
    cameraPreview: string = "Camera preview";
    joinInterviewExam: string = "Join Interview Exam";
    takeInterviewExamSEB: string = "Take Interview Exam (SEB)";
    takeExamSEB: string = "Take Exam (SEB)";
    continueExam: string = "Continue Exam";
    continueExamSEB: string = "Continue Exam (SEB)";
    examType: string = "Exam Type";
    examDuration: string = "Exam duration";
    loadingSpinner: string = "Loading...";
    errorDetails: string = "Click to show error details for exam";
    liveVideoFeed: string = "Error detailsLive video feed for face capture";
    capturedPhotoThumbnail: string = "Captured photo thumbnail";
    enter: string = "Enter";
    closeRetakeDialog: string = "Close retake dialog";
    quitSebMessage: string = "You can use this button to quit at any time";
    quitSeb: string = "Quit Secure Exam Browser session";
    exam: string = "Exam";
    questionNo: string = "Question no";
    examDate: string = "Exam date";
    checkQuality: string = "Check Quality";
    analyzingImage: string = "Analyzing image...";
    processingFaceDetection: string = "Processing face detection...";
    checkingImageQuality: string = "Checking image quality...";
    almostDone: string = "Almost done...";
    finalizingAnalysis: string = "Finalizing analysis...";
    faceNotDetectedInstruction: string = 'Face not detected. Ensure your camera is wiped clean and you are in a lit room and not backing your light source.';
    multipleFacesDetectedInstruction: string = 'Multiple faces detected. Please ensure you are the only person visible on camera.';
    poorQuality: string = 'Poor';
    warningQuality: string = 'Warning';
    goodQuality: string = 'Good';
    errorConnectingToAiProctorServer: string = 'An error occoured. Unable to connect to server';
    faceMismatchPleaseRetakeThePicture: string = 'The pictures didn\'t match perfectly. Please start over';
    pleaseKeepANeutralExpressionForTheFirstPhoto: string = 'Please keep a neutral expression for the first photo';
    pleaseSmileForTheSecondPhoto: string = 'Please smile for the second photo';
    pleaseEnsureYourFaceFillsTheCircleWhenTakingThePicture: string = 'Please ensure your face fills the circle when taking the picture. Try moving closer to the webcam';
    tryCleaningTheCameraLensAndMovingCloserToTheScreen: string = 'Try cleaning the lens of your camera and moving closer to the screen. Also ensure your face is not obstructed by any object including your hands. Keep your face visible in the circle at all times';
    startingYourExam: string = 'Starting Your Exam';
    pleaseWaitWhileWeAuthenticateYouAndStartYourExam: string = 'Please wait while we authenticate you and start/continue your exam';
    startingExamKeepEyesOnTheScreen: string = 'Keep Your eyes open and focused on the screen, and ensure your face is fully visible within the circle and fills at least 80% of the circle below. Ensure your face is not obstructed by your hands, hair or any other object';
    primaryRecordingVerificationFailureMessage: string = 'Video streaming failed. Please check your internet connection and/or restart your modem';
    secondViewRecordingVerificationFailureMessage: string = 'Second view Video streaming failed. Please check your internet connection on your device(s) and/or restart your modem. If you are using a mobile device, check that it is still on and connected to the internet';
    paused: string = 'paused';
    networkCheck: string = 'Network Check';
    latency: string = 'Latency';
    speed: string = 'Speed';
    failureToComplyMayResultInDisqualification: string = 'Failure to comply may result in disqualification';
}